module.exports = __webpack_public_path__ + "static/media/angel.6683730e.mp3";